import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Tooltip } from "@mui/material";

import {
	TEST_SHACK_REPORT_STATUS,
	type TestShackReportStatus,
} from "@/pages/products/test-shack/models/TestShackReport";
import { STATUS_LABEL } from "@/pages/products/test-shack/utils/reportFormat";

interface TestShackReportStatusArrowProps {
	status: TestShackReportStatus;
}

const ARROW_SX = {
	color: "error.main",
	display: "block",
	fontSize: 13,
} as const;

/** NO/NG readings are already red text, so only Over/Under get an arrow. */
export const TestShackReportStatusArrow = ({
	status,
}: TestShackReportStatusArrowProps) => {
	if (
		status !== TEST_SHACK_REPORT_STATUS.OVER &&
		status !== TEST_SHACK_REPORT_STATUS.UNDER
	)
		return null;

	return (
		<Tooltip title={STATUS_LABEL[status]}>
			{status === TEST_SHACK_REPORT_STATUS.OVER ? (
				<ArrowUpwardIcon aria-label={STATUS_LABEL[status]} sx={ARROW_SX} />
			) : (
				<ArrowDownwardIcon aria-label={STATUS_LABEL[status]} sx={ARROW_SX} />
			)}
		</Tooltip>
	);
};
